import _ from 'underscore';

import Layout from '../views/list';
import Epayment from '../models/epayment';

module.exports = function (options) {
  const regionManager = new Marionette.RegionManager({
    regions: {
      layout: '#import-hook'
    }
  });
  options = _.clone(options);
  options.model = new Epayment();

  const layoutView = new Layout(options);
  regionManager.get('layout').show(layoutView);
};



// WEBPACK FOOTER //
// ./epayment_import/initializers/list.js